import * as React from 'react';

import { StileGtagEventName } from '../../../../types/services';

import { tagEvent } from '../../../../utils/tagEvent';

import { Link } from '../Link';
import './Button.css';

type ButtonProps = React.HTMLAttributes<HTMLAnchorElement> &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children?: never;
    style?: 'primary' | 'secondary' | 'grey' | 'dark' | 'white';
    size?: 'small' | 'normal' | 'large';
    label: string | React.ReactNode;
    href?: string;
    gtagEvent?: StileGtagEventName;
    external?: boolean;
    newTab?: boolean;
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
    onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    disabled?: React.ButtonHTMLAttributes<HTMLButtonElement>['disabled'];
  };

/**
 * Displays stile Button in different colours
 */
export const Button = ({
  style = 'primary',
  size = 'normal',
  label,
  href,
  external,
  newTab = false,
  className,
  type = 'button',
  onClick,
  disabled,
  gtagEvent,
  ...props
}: React.PropsWithChildren<ButtonProps>) => {
  const buttonClassName = `button --${style} --${size} ${className || ''}`;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    gtagEvent && tagEvent(gtagEvent);
    onClick && onClick(event);
  };

  // If type is specified or no href is provided, render as a button
  if (type != 'button' || !href) {
    return (
      <button
        type={type}
        className={buttonClassName}
        onClick={handleClick}
        disabled={disabled}
        {...props}
      >
        {label}
      </button>
    );
  } else {
    return (
      <Link
        url={href}
        className={buttonClassName}
        external={external}
        target={newTab ? '_blank' : undefined}
        onClick={handleClick}
        variant="unstyled"
        {...props}
      >
        {label}
      </Link>
    );
  }
};
